import { eligibleSessionAuditItems } from "@p0security/shared/integrations/resources/postgres/install-options";
import {
  integrationOptionProvider,
  otherInstalledIntegration,
} from "components/Integrations/utils/resourcesInstalledUtil";

import { RowSecurityPolicyFooter } from "./row-security.tsx";
import { AwsConfigs, PgInstaller } from "./types";

export const pgInstaller = (aws: AwsConfigs): PgInstaller => ({
  "iam-write": {
    items: {
      hosting: {
        options: {
          "gsm-static": {
            items: {
              project: {
                optionProvider: otherInstalledIntegration({
                  integration: "gcloud",
                  component: "secret-manager",
                }),
              },
            },
          },
        },
      },
    },
  },
  "row-security-policy": {
    labeler: () => "Create a unique name for this row security policy",
    footer: (_context, _policyId, config) => (
      <RowSecurityPolicyFooter config={config} />
    ),
    items: {
      instance: {
        optionProvider: otherInstalledIntegration({
          integration: "pg",
          component: "iam-write",
        }),
      },
    },
  },
  "session-audit": {
    optionProvider: async ({ config }) => {
      const eligibleItems = eligibleSessionAuditItems(config);
      return eligibleItems.map(([id, item]) => ({
        id,
        label: item?.label,
      }));
    },
    labeler: () => (
      <>
        Please choose the existing Postgres access-management integration to
        extend with session audit.
      </>
    ),
    items: {
      functionCaller: {
        optionProvider: integrationOptionProvider("session-audit", [
          {
            firestoreRef: aws,
            component: "function-caller",
            labelTitle: "AWS Lambda",
            keyPrefix: "aws",
          },
        ]),
      },
    },
  },
});
